'use client';
import React from 'react';

import PrimaryButton, {
  type PrimaryButtonData,
} from '@/components/ui/Button/PrimaryButton';
import RichText, { StyleOverrides } from '@/components/ui/RichText/RichText';

type Styles = StyleOverrides;

type TextBlock = {
  content?: string;
  styles?: Styles;
};

type FeatureGridItem = {
  heading?: TextBlock;
  description?: TextBlock;
};

type FeatureGridSectionData = {
  items?: FeatureGridItem[];
  button?: PrimaryButtonData;
};

type FeatureGridSectionProps = {
  data: FeatureGridSectionData;
  className?: string;
};

const FeatureGridSection = ({
  data,
  className = '',
}: FeatureGridSectionProps) => {
  const [introItem, ...cardItems] = data.items || [];

  return (
    <section
      className={`bg-surface-light tablet:py-12 laptop:py-15 w-full py-10 ${className} `}
    >
      <div className="content-wrapper">
        <div className="tablet:grid-cols-2 tablet:gap-6 laptop:gap-8 grid grid-cols-1 gap-4">
          {introItem && (
            <div className="tablet:gap-4 laptop:gap-5 flex flex-col gap-3">
              {introItem.heading?.content && (
                <RichText styles={introItem.heading.styles}>
                  {introItem.heading.content}
                </RichText>
              )}

              {introItem.description?.content && (
                <RichText styles={introItem.description.styles}>
                  {introItem.description.content}
                </RichText>
              )}
            </div>
          )}

          {cardItems.map((item, index) => (
            <article
              className="tablet:p-5 tablet:gap-4 laptop:p-6 laptop:gap-4 flex flex-col gap-3 rounded-2xl bg-white p-4"
              key={`${item.heading?.content || 'item'}-${index}`}
            >
              {item.heading?.content && (
                <RichText styles={item.heading.styles}>
                  {item.heading.content}
                </RichText>
              )}

              {item.description?.content && (
                <RichText
                  styles={item.description.styles}
                  className="tablet:leading-6 leading-5"
                >
                  {item.description.content}
                </RichText>
              )}
            </article>
          ))}
        </div>

        {data.button && (
          <div className="tablet:mt-8 laptop:mt-10 mt-6 flex justify-center">
            <PrimaryButton
              className="tablet:w-auto"
              data={{
                ...data.button,
                title: data.button.content || '',
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default FeatureGridSection;
